// removed by extract-text-webpack-plugin
module.exports = {"spin":"_3nzicNTBGazg6JDPIflykL"};


//////////////////
// WEBPACK FOOTER
// ./src/public/components/View/Table/styles.scss
// module id = 920
// module chunks = 18